import { render, staticRenderFns } from "./home_footer.vue?vue&type=template&id=364a2e84&scoped=true&"
import script from "./home_footer.vue?vue&type=script&lang=js&"
export * from "./home_footer.vue?vue&type=script&lang=js&"
import style0 from "./home_footer.vue?vue&type=style&index=0&id=364a2e84&prod&scoped=true&lang=css&"
import style1 from "./home_footer.vue?vue&type=style&index=1&id=364a2e84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a2e84",
  null
  
)

export default component.exports